<div class="cmps-cdk-overflow-hidden">
    <div
        class="justify-content-between cmps-cdk-d-flex cmps-cdk-px-0dot5 cmps-cdk-py-0dot5"
    >
        <div
            class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-cg-0dot5"
        >
            <div>
                <img
                    class="cmps-transcript-dialog-summary--icai"
                    src="assets/intelligent-coach-assist-icon.svg"
                    alt=""
                    aria-hidden="true"
                />
            </div>
            <div class="cmps-cdk-font-size-15p cmps-cdk-font-bold">
                {{ _i18n._11210_COACH_ASSIST_SUMMARY | translate }}
            </div>
            <div
                class="cmps-cdk-bg-color-unknown-117 cmps-cdk-border-radius-12px cmps-cdk-color-unknown-125 cmps-cdk-font-bold cmps-cdk-px-0dot5 cmps-cdk-text-uppercase cmps-cdk-white-space-nowrap"
            >
                AI Generated
            </div>
        </div>
        <div>
            <button
                class="cmps-icon-button--no-bg"
                cmpsIconButton
                [disabled]="
                    _service.state?.didAddCommitmentNoteViaSummary === true ||
                    _service.state?.didAddObservationNoteViaSummary === true
                "
                [cmpsTooltipTrigger]="
                    _i18n._9488_ADD_COMMITMENT_NOTE | translate
                "
                (click)="_onAddCommitmentNoteClick()"
            >
                <cmps-icon svgIcon="folder-account-outline"></cmps-icon>
            </button>
            <button
                class="cmps-icon-button--no-bg"
                cmpsIconButton
                [disabled]="
                    _service.state?.didAddCommitmentNoteViaSummary === true ||
                    _service.state?.didAddObservationNoteViaSummary === true
                "
                [cmpsTooltipTrigger]="
                    _i18n._11032_ADD_OBSERVATION_NOTE | translate
                "
                (click)="_onAddObservationNoteClick()"
            >
                <cmps-icon svgIcon="account-eye-outline"></cmps-icon>
            </button>
        </div>
    </div>
    <cmps-comment
        [disabled]="
            _service.state?.didAddCommitmentNoteViaSummary !== true &&
            _service.state?.didAddObservationNoteViaSummary !== true
        "
        [ngModel]="_service.state?.transcript?.caSummary?.content"
        [ngModelOptions]="{ updateOn: 'blur' }"
        (ngModelChange)="summaryChange.emit($event)"
    ></cmps-comment>
</div>
